import { render, staticRenderFns } from "./TargetObjectAttribute.vue?vue&type=template&id=add72a18&scoped=true&"
import script from "./TargetObjectAttribute.vue?vue&type=script&lang=ts&"
export * from "./TargetObjectAttribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add72a18",
  null
  
)

export default component.exports